import LottieRaw from 'lottie-react';
import data from './smiley.partial.json.js';
import { jsx } from 'react/jsx-runtime';

// @ts-expect-error Lottie-react exports their default export incorrectly.
const Lottie = LottieRaw.default ?? LottieRaw;
function PartialSmileyIcon(props) {
  return /*#__PURE__*/jsx(Lottie, {
    loop: false,
    ...props,
    animationData: data
  });
}
PartialSmileyIcon.blink = lottie => {
  if (!lottie || !lottie.animationItem) {
    return;
  }
  if (lottie.animationItem.currentFrame >= lottie.animationItem.totalFrames - 1) {
    lottie.goToAndPlay(90, true);
  }
};

export { PartialSmileyIcon };
//# sourceMappingURL=smiley.partial.js.map
